import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DesignGuideHeaderImage from '../../images/design-guidelines-header@2x.png';
import UIConfigurationImage from '../../images/ui-configurations@2x.png';
import Attribution from '../../images/attribution@2x.png';
import { InlineContainer } from '../../components/sdk-page/attribution';
import { Button } from '../../components/create-app-button';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div>
      <h2>{`Design Guidelines`}</h2>
      <InlineContainer mdxType="InlineContainer">
        <div>
          <h3>{`How to Comply with our Attribution Policy`}</h3>
          <p>{`GIPHY loves its community and we want to support our GIF and Sticker creators. We believe that they should get recognition for the content they create. That’s why we’ve included a tap and hold UI that shows the creator’s username and enables users to easily search for more content by that creator.`}</p>
          <p>{`The optional confirmation view mentioned above also includes the creator’s username, if one exists.`}</p>
        </div>
        <img style={{
          height: 150,
          marginTop: 55
        }} src={Attribution} />
      </InlineContainer>
      <h3>{`Sketch UI Kit`}</h3>
      <p>{`Ready to design your GIPHY experience? Download our Sketch UI Kit to drag and drop elements into your app and experiment with layouts, fonts, colors, and content that work best for you.`}</p>
      <Button href="https://s3.amazonaws.com/sdk.mobile.giphy.com/design/GIPHY-SDK-UI-Kit.sketch" mdxType="Button">
    Download Sketch UI Kit
      </Button>
      <h3>{`Brand Guidelines`}</h3>
      <p>{`While we have included a branded button for SDK users, you may need our logo for other purposes. Check out the links below to download GIPHY-approved logos and icons, along with our brand guidelines.`}</p>
      <p>{`For general best practices related to the GIPHY brand, see our `}<a parentName="p" {...{
          "href": "https://support.giphy.com/hc/en-us/articles/360022283772-GIPHY-Brand-Guidelines"
        }}>{`Brand Guidelines`}</a>{` and be sure to check out our `}<a parentName="p" {...{
          "href": "https://support.giphy.com/hc/en-us/articles/360027858552-Giphy-SDK-License-Agreement"
        }}>{`SDK License Agreement`}</a>{`. By using GIPHY SDK, you are agreeing to the `}<a parentName="p" {...{
          "href": "https://support.giphy.com/hc/en-us/articles/360027858552-Giphy-SDK-License-Agreement"
        }}>{`SDK License Agreement`}</a>{`.`}</p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      